import { useClinicalListsListPeople } from '~/backend/connector-next-api/connector-next-components';
import type { PatientSummaryDto } from '~/backend/connector-next-api/connector-next-schemas';
import { NO_PATIENT_FILTERS, withAssignedToUserId, type Sort } from '../model';
import { useWholePatientList } from './usePatientList';

export type TaskList = {
    patients: PatientSummaryDto[];
    /** The whole list is not known yet, also while it is held back. */
    isLoading: boolean;
    isRefreshing: boolean;
    isError: boolean;
};

/** The task list takes no search and shows the latest activity first. */
const UNSEARCHED_BY_ACTIVITY: { search: undefined; sort: Sort } = {
    search: undefined,
    sort: { key: 'lastActivity', direction: 'desc' },
};

const NO_TASKS: TaskList = {
    patients: [],
    isLoading: false,
    isRefreshing: false,
    isError: false,
};

/**
 * The patients assigned to the signed-in user, loaded while `enabled`. It
 * stays loading until the connector says who the user is, fails when that
 * cannot be read, and holds none for a caller who is no user of the
 * installation.
 */
export function useAssignedToMe(enabled: boolean): TaskList {
    const people = useClinicalListsListPeople({});
    const meId = people.data?.meId ?? undefined;
    const list = useWholePatientList({
        ...UNSEARCHED_BY_ACTIVITY,
        filters: withAssignedToUserId(NO_PATIENT_FILTERS, meId),
        enabled: enabled && meId !== undefined,
    });
    if (people.data === undefined) {
        return {
            ...NO_TASKS,
            isLoading: !people.isError,
            isError: people.isError,
        };
    }
    return meId === undefined ? NO_TASKS : list;
}
